import { AlpineComponent } from 'alpinejs';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

type ImageBreakData = {}

export default ():AlpineComponent<ImageBreakData> => ({
    init() {
        this.$lazyLoad.update();

        // Image animations
        let mm = gsap.matchMedia();

        const contentWrapper = this.$root.querySelectorAll('.ce-image-break-inner');
        const gsapText = this.$root.querySelectorAll('.ce-image-break-content-inner');
        if (contentWrapper && gsapText) {
            mm.add("(min-width: 992px)", () => {
                gsap.from(gsapText, {
                    y: 120,
                    scrollTrigger: {
                        trigger: contentWrapper,
                        scrub: true,
                        start: "top bottom",
                        end: "bottom top"
                    },
                })
            });
        }
    }
});
